export class StrategiesService {
  constructor(TwitterFactory,
    FacebookFactory,
    Instagram2Factory,
    WebchatFactory,
    GmbFactory,
    GbmFactory,
    WhatsappFactory,
    BusinessChatFactory,
    TrustpilotFactory,
    LineFactory,
    KakaotalkFactory,
    LinkedinFactory,
    TiktokFactory
  ) {

    this._all = [
      TwitterFactory,
      FacebookFactory,
      Instagram2Factory,
      WebchatFactory,
      GmbFactory,
      GbmFactory,
      WhatsappFactory,
      BusinessChatFactory,
      TrustpilotFactory,
      LineFactory,
      KakaotalkFactory,
      LinkedinFactory,
      TiktokFactory
    ];
  }

  getAll() {
    return this._all;
  }

  getStrategy(strategy) {
    return this._all.filter(s => s.getTypeString() === strategy)[0];
  }

  getStrategyFromType(type) {
    return this._all.filter(s => s.getType() === type)[0];
  }

  getOrderedSiteTypeStrings() {
    return this._all.map(strategy => strategy.getTypeString());
  }

  static StrategiesFactory(TwitterFactory,
    FacebookFactory,
    Instagram2Factory,
    WebchatFactory,
    GmbFactory,
    GbmFactory,
    WhatsappFactory,
    BusinessChatFactory,
    TrustpilotFactory,
    LineFactory,
    KakaotalkFactory,
    LinkedinFactory,
    TiktokFactory) {

    return new StrategiesService(TwitterFactory,
      FacebookFactory,
      Instagram2Factory,
      WebchatFactory,
      GmbFactory,
      GbmFactory,
      WhatsappFactory,
      BusinessChatFactory,
      TrustpilotFactory,
      LineFactory,
      KakaotalkFactory,
      LinkedinFactory,
      TiktokFactory
    );
  }
}
StrategiesService.StrategiesFactory.$inject = ['TwitterFactory',
  'FacebookFactory',
  'Instagram2Factory',
  'WebchatFactory',
  'GmbFactory',
  'GbmFactory',
  'WhatsappFactory',
  'BusinessChatFactory',
  'TrustpilotFactory',
  'LineFactory',
  'KakaotalkFactory',
  'LinkedinFactory',
  'TiktokFactory'];
